import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import localStrings from "../../../localStrings";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {Link as RouterLink} from "react-router-dom";
import {chartCategoryListRoute, dashboardBaseRoute,} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import ChartCategoryCreateUpdateForm from "../ChartCategoryAddView/ChartCategoryCreateUpdateForm";

const ChartImplementationDetailsView = () => {

  const searchParams = new URLSearchParams(window.location.search);
  const urlBack = searchParams.get('urlBack');
  const urlBackTitle = searchParams.get('urlBackTitle');


  function getMainButtons() {
    return (
      <>
        {urlBack && urlBackTitle &&
          <RouterLink to={decodeURI(urlBack)}
                      style={{ textDecoration: 'none' }}
          >
            <Button
              color="primary"
              variant="contained"
              startIcon={(
                <SvgIcon>
                  <ArrowBackIcon />
                </SvgIcon>
              )}
            >
              {urlBackTitle}
            </Button>
          </RouterLink>
        }
        <RouterLink to={'/' + dashboardBaseRoute + '/' + chartCategoryListRoute}
                    style={{ textDecoration: 'none' }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={(
              <SvgIcon>
                <ArrowBackIcon />
              </SvgIcon>
            )}
          >
            {localStrings.backToList}
          </Button>
        </RouterLink>
      </>
    )
  }

  return (
    <PageWithTitle title={localStrings.chartCategory} mainButtons={getMainButtons()}>
        <ChartCategoryCreateUpdateForm modeEdit={MODE_EDIT}/>
    </PageWithTitle>
  );
};

export default ChartImplementationDetailsView;
